<div class="buffer-slider" #sliderContainer>
  <span class="label">{{ label }}:</span>
  <span class="value">{{ value }}</span>

  <!-- TODO: The 'tickInterval' property no longer exists -->
  <mat-slider
    [disabled]="!!filterService.isBufferDisable"
    [min]="min"
    [max]="max"
    [step]="step"
    thumbLabel="false"
    class="custom-slider" #ngSlider><input matSliderThumb [value]="value" (input)="onValueChange({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value}.value||0)" #ngSliderThumb="matSliderThumb" />
  </mat-slider>
</div>
